module.exports = __webpack_public_path__ + "img/anchor_birds_rec.f0b33532.png";